export default function getDataAttributeToJON(element_id, data_attribute_name) {
  let data    = null,
      element = document.getElementById(element_id)

  if (element.dataset.content){
    data = JSON.parse(element.dataset[data_attribute_name])
  }

  return data;
}
